import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./profilePage.css";
import { SEO } from "@/components/SEO/SEO";
import { useAuth } from "@/_zustand/auth";
import { useCompanyFlow } from "@/hooks/useCompanyFlow";
import { ProfileForm } from "./ProfileForm";
import { PasswordForm } from "./PasswordForm";
import { WalletForm } from "./WalletForm";
import { Coupons } from "./Coupons";

export const ProfilePage = () => {
  const { user } = useAuth();
  const { getCompanyRoute } = useCompanyFlow();
  const navigate = useNavigate();
  const location = useLocation();

  // Obtener parámetros de búsqueda
  const queryParams = new URLSearchParams(location.search);
  const initialSection = queryParams.get("TBK_TOKEN") ? "wallet" : "profile";

  const [activeSection, setActiveSection] = useState(initialSection);
  const [walletRefreshKey, setWalletRefreshKey] = useState(0);

  const triggerWalletRefresh = () => {
    setWalletRefreshKey((prev) => prev + 1);
    // Opcional: También asegúrate de que se muestre la vista correcta
    setActiveSection("wallet");
  };

  const renderSection = () => {
    // ⭐️ La clave: Se pasa setActiveSection como prop a todos los componentes.
    const commonProps = {
      setActiveSection,
      // ⭐️ 2. Pasa la función de recarga a las vistas
      triggerWalletRefresh,
    };

    switch (activeSection) {
      case "profile":
        return <ProfileForm />;
      case "wallet":
        return (
          <WalletForm
            {...commonProps}
            refreshKey={walletRefreshKey}
            triggerWalletRefresh={triggerWalletRefresh}
          />
        );
      case "coupons":
        return <Coupons />;
      case "password":
        return <PasswordForm />;
      case "contact":
        return navigate(getCompanyRoute("contact"));
      default:
        return null;
    }
  };

  return (
    <div className="profile-container" style={{ flexGrow: 1 }}>
      <SEO title="Mi perfil" noIndex={true} />
      <aside className="profile-sidebar">
        <h2 className="profile-sidebar-title">¡Hola {user.usuario_nombre}!</h2>
        <ul className="profile-sidebar-menu">
          <li
            className={
              activeSection === "profile"
                ? "profile-sidebar-item active"
                : "profile-sidebar-item"
            }
            onClick={() => setActiveSection("profile")}
          >
            Datos personales
          </li>
          <li
            className={
              activeSection === "password"
                ? "profile-sidebar-item active"
                : "profile-sidebar-item"
            }
            onClick={() => setActiveSection("password")}
          >
            Contraseña
          </li>
          <li
            className={
              activeSection === "wallet"
                ? "profile-sidebar-item active"
                : "profile-sidebar-item"
            }
            onClick={() => setActiveSection("wallet")}
          >
            Billetera
          </li>
          {/* <li className={activeSection === 'coupons' ? 'profile-sidebar-item active' : 'profile-sidebar-item'}
        onClick={() => setActiveSection('coupons')}
        >Cupones</li> */}
          <li
            className={
              activeSection === "contact"
                ? "profile-sidebar-item active"
                : "profile-sidebar-item"
            }
            onClick={() => navigate(getCompanyRoute("contact"))}
          >
            ¡Contáctanos!
          </li>
        </ul>
        <div className="profile-sidebar-invite">
          <p>
            <strong>¡Invita a un amigo!</strong>
            <br />
            Obtén un descuento especial por cada amigo que descargue la app
          </p>
          <button className="profile-invite-button">Invitar amigos</button>
        </div>
        <ul className="profile-sidebar-footer">
          <li>
            <a
              className="sidebar-link"
              href="https://openmaticmarket.com/Politica_Privacidad_OpenMatic.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacidad
            </a>
          </li>
          <li>
            <a
              className="sidebar-link"
              href="https://openmaticmarket.com/Terminos_Condiciones_OpenMatic.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Términos y condiciones
            </a>
          </li>
          {/* <li>Eliminar cuenta</li> */}
          <li className="profile-version">Versión 2.0.0828</li>
        </ul>
      </aside>

      {renderSection()}
    </div>
  );
};
